import React from 'react';
import { useNavigate } from 'react-router-dom';
import GenericFeatureList from '../shared/generic-feature-list';
import { ReelTrendingAPI } from '../../services/feature-api';
import { getFeatureConfig } from '../../config/featureDisplayConfig';

const config = getFeatureConfig('reel-trending');

const fetchData = async (accessToken, filters) => {
  const result = await ReelTrendingAPI.getList(accessToken, filters);
  const items = result.success ? (result.data?.rows || result.data?.items || []) : [];
  const list = Array.isArray(items) ? items : [];
  return {
    items: list,
    summary: {
      total: list.length,
      totalViews: list.reduce((sum, r) => sum + (Number(r.viewCount) || 0), 0),
      approved: list.filter((r) => r.companyApproved === 'approved').length,
      pending: list.filter((r) => r.companyApproved === 'pending').length,
    },
  };
};

const ReelTrendingList = (props) => {
  const navigate = useNavigate();
  return (
    <GenericFeatureList
      title={config.listConfig.title}
      fetchData={fetchData}
      columns={config.listConfig.columns}
      summaryFields={config.listConfig.summaryFields}
      displayMode={config.listConfig.displayMode}
      createPath={config.createPath}
      notice={config.notice}
      guideUrl={config.guideUrl}
      accentColor={config.color}
      onItemClick={(item) => navigate(config.editPath, { state: { editData: item } })}
      {...props}
    />
  );
};

export default ReelTrendingList;
